<template>
    <rd-container size="large">
        <rd-header :text = "$t('index.processTree')" style="margin-left: 0!important; margin-right: 0!important">
            <dx-button :use-submit-behavior="false"
                       type="normal"
                       class="mr-1"
                       :text = "$t('form.folder.add.title')"
                       @click="addFolder"
                       :hint = "$t('form.folder.add.title')">
                <i class="far fa-folder ml-1 mr-1" style="font-size: 1.4rem;"></i>
            </dx-button>
            <dx-button :use-submit-behavior="false"
                       type="normal" 
                       class="mr-1"
                       :text = "$t('form.processLink.add.title')"
                       @click="addStartStepLink"
                       :hint="$t('form.processLink.add.title')">
                       
                <i class="far fa-project-diagram ml-1 mr-1" style="font-size: 1.4rem;"></i>
            </dx-button>
            <dx-button :use-submit-behavior="false"
                       type="normal"
                       class="mr-1"
                        :text = "$t('form.gridLink.add.title')"
                       @click="addGridLink"
                       :hint = "$t('form.gridLink.add.title')">
                       
                <i class="far fa-list ml-1 mr-1" style="font-size: 1.4rem;"></i>
            </dx-button>
            <dx-button :use-submit-behavior="false"
                        type="normal"
                       class="mr-1"
                       :text = "$t('form.link.add.title')"
                       @click="addLink"
                       :hint="$t('form.link.add.title')">
                       
                <i class="far fa-external-link ml-1 mr-1" style="font-size: 1.4rem;"></i>
            </dx-button>            
            <dx-button :use-submit-behavior="false"
                       type="normal"
                       class="mr-1"
                       :text = "$t('form.routeLink.add.title')"
                       @click="addRouteLink"
                       :hint="$t('form.routeLink.add.title')">
                       
                       
                <i class="far fa-link ml-1 mr-1" style="font-size: 1.4rem;"></i>
            </dx-button>
        </rd-header>
        <div class="row">
            <rd-column :size="$columns.FullWidth">
                <DxTreeList ref="tree-list"
                            :data-source="internalData"
                            :root-value="-1"
                            :show-row-lines="false"
                            :show-column-lines="false"
                            :show-borders="false"
                            :row-alternation-enabled="true"
                            :show-column-headers="true"
                            :expanded-row-keys="expandedRowKeys"
                            :auto-expand-all="false"
                            @cell-click="onCellClick"
                            @row-expanded="onRowCollapsedExpanded"
                            @row-collapsed="onRowCollapsedExpanded"
                            @row-prepared="onRowPrepared"
                            :on-content-ready="onContentReady"
                            key-expr="Id"
                            :preload-enabled="true"
                            parent-id-expr="ParentId"
                            :search-panel="{
                        visible: false,
                        placeholder: 'Szukaj...',
                        height: '30px',
                      }"
                            class="folder-tree-custom"
                            :focused-row-enabled="false"
                            @nodes-initialized="onNodesInitialized">
                    <DxLoadPanel :enabled="false" />

                    <DxRowDragging :on-drag-change="onDragChange"
                                   :on-reorder="onReorder"
                                   :allow-drop-inside-item="true"
                                   :allow-reordering="true"
                                   :show-drag-icons="true"
                                   :on-drag-end="onDragEnd"
                                   :on-drag-move="onDragMove" />
                    <!--<DxColumn type="buttons" :width="80">
            <TreeListButton hint="Zmień kolejność"
                      icon="dragvertical">
            </TreeListButton>
        </DxColumn>-->
                    <DxColumn data-field="Id" :allow-sorting="false" :visible="false" />
                    <DxColumn data-field="Name"
                              v-if="mobileViewMode"
                              :caption = "$t('index.captions.name')"
                              :allow-sorting="true"  
                              :width="200"                      
                              cell-template="fullNameTemplate" />
                    <DxColumn data-field="Name"
                              v-else
                              :caption = "$t('index.captions.name')"
                              :allow-sorting="true"                      
                              cell-template="fullNameTemplate" />
                    <DxColumn data-field="Description"
                              v-if="mobileViewMode"
                              :width="100"
                              :caption = "$t('index.captions.description')"
                              :allow-sorting="true" />
                    <DxColumn data-field="Description"
                              v-else
                              :caption = "$t('index.captions.description')"
                              :allow-sorting="true" />
                    <DxColumn data-field="ItemType" :visible="false" :allow-sorting="false" />
                    <DxColumn data-field="ParentId" :allow-sorting="false" :visible="false" />
                    <DxColumn data-field=""
                              v-if="smallMobileView"
                              :caption="$t('index.captions.actions')"
                              :allow-sorting="false"
                              :width="100"  
                              alignment="center"
                              cell-template="buttonsTemplate" />
                    <DxColumn data-field=""
                              v-else
                              :caption="$t('index.captions.actions')"
                              :allow-sorting="false"
                              alignment="center"
                              cell-template="buttonsTemplate" />
                    <DxScrolling column-rendering-mode="virtual"/>
                    <template #fullNameTemplate="{ data }">
                        <template v-if="data.data.ItemType === 0">
                            <div class="folder-tree-custom-el">
                                <span class="icon"></span>
                                {{ data.data.Name }}
                                <span class="sidebar-quantity" v-if="getItemCount(data.data) > 0">
                                    {{ getItemCount(data.data) }}
                                </span>
                            </div>
                        </template>
                        <template v-else-if="data.data.ItemType !== 0">
                            <div class="folder-tree-custom-el">
                                <span>
                                    <span :class="data.data.Icon || 'fas fa-link'"></span>
                                    {{ data.data.Name }}
                                </span>
                            </div>
                        </template>
                    </template>
                    <template #buttonsTemplate="{ data }">
                        <div>
                            <span :hint="$t('buttons.edit')" :title="$t('buttons.edit')" class="action-btn" @click="editItem(data.data.Id, data.data.ItemType)"><i class="fas fa-pencil"></i></span>
                            <span v-if="data.data.ItemType === 0 || data.data.ItemType === 1 || data.data.ItemType === 2 || data.data.ItemType === 3 || data.data.ItemType === 4"
                                  :hint="$t('buttons.delete')" :title="$t('buttons.delete')" class="action-btn" @click="showDeletePopup(data)" ><i class="fas fa-trash"></i></span>
                        </div>
                    </template>
                </DxTreeList>

              <rd-form-actions>
                    <dx-button :text = "$t('index.captions.publish')"
                                type="default"
                                :style="{'margin-right': mobileViewMode ? '1rem': '0'}"
                                @click="publishInternal"/>
                </rd-form-actions>

                <folder ref="folderConfiguration" @confirm="folderConfirm" />
                <simple-link ref="simpleLinkConfiguration" @confirm="simpleLinkConfirm" />
                <process-link ref="processLinkConfiguration" @confirm="processLinkConfirm" />
                <grid-link ref="gridLinkConfiguration" @confirm="gridLinkConfirm" />
                <route-link ref="routeLinkConfiguration" @confirm="routeLinkConfirm" />
                <!-- Delete -->
                <rd-popup :visibility="popupOptions.popupVisible"
                          :title="$t('popup.title.deleteElement')">
                    <rd-popup-content>
                        <div class="row">
                            <rd-column :size="$columns.TwelveOnLg">


                                <label>{{ popupOptions.name }} </label> 


                            </rd-column>
                        </div>
                    </rd-popup-content>
                    <rd-popup-actions>
                        <dx-button :type="cancelBtnOption.type"
                                   styling-mode="text"
                                   :text="cancelBtnOption.text"
                                   @click="hideDeletePopup()" />
                        <dx-button :type="deleteBtnOption.type"
                                   class="ml-1"
                                   :text="deleteBtnOption.text"
                                   @click="deleteItemInternal(popupOptions.id)" />
                    </rd-popup-actions>
                </rd-popup>

            </rd-column>
        </div>
    </rd-container>
</template>
<script>
    // @ is an alias to /src
    import DxButton from 'devextreme-vue/button';
    import {
        DxTreeList,
        DxColumn,
        DxRowDragging,
        DxLoadPanel,
        DxScrolling,
    } from "devextreme-vue/tree-list";

    import "../components/SideNav.scss";

    import { mapActions } from "vuex";
    import Folder from "../components/Folder";
    import SimpleLink from "../components/SimpleLink";
    import ProcessLink from "../components/ProcessLink";
    import GridLink from "../components/GridLink";
    import RouteLink from "../components/RouteLink";

    import commonMessages from "../../locales";
    import localMessages from "../locales";

    const INDEX_STORE = "administrationStores/menuStores/menuTreeStores/indexStore";


    export default {
        name: "menuTree",
        props: ["componentConfig"],
        data() {
            return {
                isSelected: false,
                internalData: [],
                showDragIcons: false,
                lastSelectedTreeListRowKey: null,
                isDrag: false,
                token: null,
                popupOptions: {
                    popupVisible: false,
                    id: null,
                    name: "",
                    
                },
                cancelBtnOption: {
                    type: "normal",
                    text: this.$t("buttons.cancel"),
                },
                deleteBtnOption: {
                    type: "danger",
                    text: this.$t("buttons.delete"),
                },
                mobileViewMode: false,
                smallMobileView: false,
                window: {
                    width: 0,
                },
            };
        },
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();
        },
        computed: {
            getSourceItems: function () {
                return this.internalData;
            },
            expandedRowKeys: function () {
                let expandedRowKeys;
                let localStorageExpandedRowKeys = localStorage.getItem(
                    "treeListExpandedRowKeys"
                );
                if (localStorageExpandedRowKeys) {
                    expandedRowKeys = localStorageExpandedRowKeys.split(",");
                } else {
                    expandedRowKeys = [1];
                }
                return expandedRowKeys;
            },
        },
        mounted() {
            this.setToken();
            this.getTreeData().then((items) => {
                this.internalData = items;
            });
        },
        methods: {
            ...mapActions(INDEX_STORE, ["getTreeData", "saveTreeOrders", "setToken", "deleteItem", "publish"]),
            folderConfirm: function (result) {
                if (result.formState === 0) {
                    var folder = {
                        Id: result.id,
                        ItemType: 0,
                        Name: result.name,
                        Description: result.description,
                        ParentId: null,
                    };
                    this.internalData.push(folder);
                    this.saveTreeOrders(this.internalData).then((items) => {
                        this.internalData = items;
                    });
                } else {
                    var editFolder = this.internalData.find((x) => x.Id === result.id);
                    editFolder.Name = result.name;
                    editFolder.Description = result.description;
                }
            },
            simpleLinkConfirm: function (result) {
                if (result.formState === 0) {
                    var link = {
                        Id: result.id,
                        ItemType: 1,
                        Link: result.link,
                        Icon: result.icon,
                        Name: result.name,
                        Description: result.description,
                        ParentId: null,
                    };
                    this.internalData.push(link);
                    this.saveTreeOrders(this.internalData).then((items) => {
                        this.internalData = items;
                    });
                } else {
                    var editLink = this.internalData.find((x) => x.Id === result.id);
                    editLink.Name = result.name;
                    editLink.Link = result.link;
                    editLink.Icon = result.icon;
                    editLink.Description = result.description;
                }
            },
            processLinkConfirm: function (result) {
                if (result.formState === 0) {
                    var link = {
                        Id: result.id,
                        ItemType: 3,
                        StepId: result.stepId,
                        Icon: result.icon,
                        Name: result.name,
                        Description: result.description,
                        ParentId: null,
                    };
                    this.internalData.push(link);
                    this.saveTreeOrders(this.internalData).then((items) => {
                        this.internalData = items;
                    });
                } else {
                    var editLink = this.internalData.find((x) => x.Id === result.id);
                    editLink.Name = result.name;
                    editLink.StepId = result.stepId;
                    editLink.Icon = result.icon;
                    editLink.Description = result.description;
                }
            },
            gridLinkConfirm: function (result) {
                if (result.formState === 0) {
                    var link = {
                        Id: result.id,
                        ItemType: 2,
                        GridId: result.gridId,
                        Icon: result.icon,
                        Name: result.name,
                        Description: result.description,
                        ParentId: null,
                    };
                    this.internalData.push(link);
                    this.saveTreeOrders(this.internalData).then((items) => {
                        this.internalData = items;
                    });
                } else {
                    var editLink = this.internalData.find((x) => x.Id === result.id);
                    editLink.Name = result.name;
                    editLink.GridId = result.gridId;
                    editLink.Icon = result.icon;
                    editLink.Description = result.description;
                }
            },
            routeLinkConfirm: function (result) {
                if (result.formState === 0) {
                    var link = {
                        Id: result.id,
                        ItemType: 4,
                        Route: result.link,
                        Icon: result.icon,
                        Name: result.name,
                        Description: result.description,
                        ParentId: null,
                    };
                    this.internalData.push(link);
                    this.saveTreeOrders(this.internalData).then((items) => {
                        this.internalData = items;
                    });
                } else {
                    var editLink = this.internalData.find((x) => x.Id === result.id);
                    editLink.Name = result.name;
                    editLink.Icon = result.icon;
                    editLink.Route = result.route;
                    editLink.Description = result.description;
                }
            },
            onContentReady: function (e) {
                let lastSelectedTreeListRowKey = this.lastSelectedTreeListRowKey;
                let treeListInstance = this.$refs["tree-list"].instance;
                if (lastSelectedTreeListRowKey && !this.isSelected) {
                    treeListInstance.option("focusedRowKey", lastSelectedTreeListRowKey);
                    treeListInstance.option("navigateToRow", lastSelectedTreeListRowKey);
                    this.isSelected = true;
                }
            },
            onRowPrepared: function (e) {
                //if (e.data.ItemType == 4) {
                //    if (this.$route.name == e.data.Route) {
                //        this.lastSelectedTreeListRowKey = e.key;
                //        e.rowElement.classList.add("rd-is-focused");
                //        return;
                //    }
                //}
                //let param = this.$route.params.processSymbol || this.$route.params.gridSymbol;
                //let symbol = e.data.ProcessSymbol || e.data.GridSymbol;
                //if (symbol && param) {
                //    if (param == symbol) {
                //        this.lastSelectedTreeListRowKey = e.key;
                //        e.rowElement.classList.add("rd-is-focused");
                //        return;
                //    }
                //}
            },
            saveForm: function (e) {
                let validateResult = this.$refs["validationGroup"].instance.validate();
                if (validateResult.isValid) {
                    this.editPopup.title = null;
                    this.editPopup.visible = false;
                    this.editPopup.data = null;
                    this.editTreeElement();
                }
            },
            onNodesInitialized: function (e) {
                e.component.forEachNode(e.root.children, function (node) {
                    if (node.visible && !node.hasChildren && node.children.length) {
                        node.hasChildren = true;
                        node.children.forEach(function (node) {
                            node.visible = true;
                        });
                    }
                });
            },
            onRowCollapsedExpanded: function (e) {
                let expandedRowKeys = this.$refs["tree-list"].instance.option(
                    "expandedRowKeys"
                );
                localStorage.removeItem("treeListExpandedRowKeys");
                localStorage.setItem("treeListExpandedRowKeys", expandedRowKeys);
            },
            onCellClick: function (e) {
                if (e.event.target.classList.contains("folder-tree-el")) {
                    e.row.isSelected = false;
                    var rowKey = e.row.key;
                    var rowIndex = e.row.rowIndex;
                    var isExpanded = e.row.cells[0].row.isExpanded;

                    if (isExpanded) {
                        e.component.collapseRow(rowKey);
                    } else {
                        e.component.expandRow(rowKey);
                    }
                    e.component.navigateToRow(rowKey);
                }
                e.row.isSelected = false;
            },
            onDragEnd: function (e) {
                var rowKey = e.toComponent.getKeyByRowIndex(e.toIndex);
                var rowData = e.toComponent.getNodeByKey(rowKey).data;
                if (e.dropInsideItem && rowData.ItemType !== 0) {
                    e.cancel = true;
                }
            },
            editItem: function (id, itemType) {
                switch (itemType) {
                    case 0:
                        this.$refs.folderConfiguration.editFolder(id);
                        break;
                    case 1:
                        this.$refs.simpleLinkConfiguration.editLink(id);
                        break;
                    case 2:
                        this.$refs.gridLinkConfiguration.editLink(id);
                        break;
                    case 3:
                        this.$refs.processLinkConfiguration.editLink(id);
                        break;
                    case 4:
                        this.$refs.routeLinkConfiguration.editLink(id);
                        break;
                }
            },
            addFolder: function () {
                this.$refs.folderConfiguration.addFolder();
            },
            addLink: function () {
                this.$refs.simpleLinkConfiguration.addLink();
            },
            addStartStepLink: function () {
                this.$refs.processLinkConfiguration.addLink();
            },
            addGridLink: function () {
                this.$refs.gridLinkConfiguration.addLink();
            },
            addRouteLink: function () {
                this.$refs.routeLinkConfiguration.addLink();
            },
            onDragMove: function (e) {
                var rowKey = e.toComponent.getKeyByRowIndex(e.toIndex);
                var rowData = e.toComponent.getNodeByKey(rowKey).data;

                if (rowData.ItemType !== 0) {
                    e.toComponent.$element()[0].style.border = "none";
                }
            },
            onDragChange(e) {
                let visibleRows = e.component.getVisibleRows(),
                    sourceNode = e.component.getNodeByKey(e.itemData.Id),
                    targetNode = visibleRows[e.toIndex].node;

                while (targetNode && targetNode.data) {
                    if (targetNode.data.Id === sourceNode.data.Id) {
                        e.cancel = true;
                        break;
                    }
                    targetNode = targetNode.parent;
                }
            },
            onReorder(e) {
                let visibleRows = e.component.getVisibleRows(),
                    sourceData = e.itemData,
                    targetData = visibleRows[e.toIndex].data;

                if (e.dropInsideItem) {
                    e.itemData.ParentId = targetData.Id;
                    e.component.refresh();
                } else {
                    let sourceIndex = this.getSourceItems.indexOf(sourceData),
                        targetIndex = this.getSourceItems.indexOf(targetData);

                    if (sourceData.ParentId !== targetData.ParentId) {
                        sourceData.ParentId = targetData.ParentId;
                        if (e.toIndex > e.fromIndex) {
                            targetIndex++;
                        }
                    }
                    this.getSourceItems.splice(sourceIndex, 1);
                    this.getSourceItems.splice(targetIndex, 0, sourceData);
                }
                this.recountItemCounts();

                this.saveTreeOrders(this.internalData).then((items) => {
                    this.internalData = items;
                });

            },
            getItemById: function (id) {
                var item = null;
                this.getSourceItems.forEach((el, i) => {
                    if (el.Id === id) {
                        item = el;
                        return;
                    }
                });
                return item;
            },
            getItemCount: function (data) {
                return data.ItemCount;
            },
            recountItemCounts: function () {
                this.getSourceItems.forEach((el, i) => {
                    if (el.ItemType === 0) {
                        el.ItemCount = 0;
                        return;
                    }
                });
                this.getSourceItems.forEach((el, i) => {
                    if (el.ItemType === 2) {
                        var parentId = el.ParentId;
                        while (parentId != null) {
                            var parent = this.getItemById(parentId);
                            parent.ItemCount += el.ItemCount;
                            parentId = parent.ParentId;
                        }
                        return;
                    }
                });
            },
            publishInternal: function () {
                this.publish().then((result) => {

                    let notificationMessage = "",
                        notificationType = "";

                    if (result) {
                        notificationMessage = this.$t('index.captions.saved');
                        notificationType = 'success';
                    } else {
                        notificationMessage = this.$t('index.captions.saveFailed');
                        notificationType = 'success';
                    }

                    this.$notify({
                        width: 'auto',
                        position: { my: 'center bottom', at: 'center bottom', of: window, collision: 'fit', offset: '0 -5' },
                        displayTime: 1800,
                        message: notificationMessage,
                        type: notificationType,
                    });
                });
            },
            showDeletePopup(options) {
                this.popupOptions.name = this.$t("popup.title.deleteElementDesc", { element: options.data.Name });
                this.popupOptions.id = options.data.Id;
                this.popupOptions.popupVisible = true;
            },
            hideDeletePopup() {
                this.popupOptions.popupVisible = false;
            },
            deleteItemInternal: function (id) {
                this.deleteItem({ id: id, items: this.internalData }).then(() => {
                    const index = this.internalData.findIndex((x) => x.Id === id);
                    if (index > -1) {
                        this.internalData.splice(index, 1);
                    }
                });
                this.popupOptions.popupVisible = false;
            },
            handleResize() {
                this.window.width = window.innerWidth;
            },
        },
        watch: {
            "window.width": function (width) {
                width < 980 ? this.mobileViewMode = true : this.mobileViewMode = false;
                width < 415 ? this.smallMobileView = true : this.smallMobileView = false;
            },
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
        },
        components: {
            DxTreeList,
            DxColumn,
            DxRowDragging,
            DxLoadPanel,
            Folder,
            SimpleLink,
            ProcessLink,
            GridLink,
            RouteLink,
            DxButton,
            DxScrolling,
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages,
        },
    };
</script>
<style scoped>
@media(max-width: 980px) {
    .rd-header {
        justify-content: center !important;
    }
}

@media(max-width: 360px) {
    .mr-1 {
        margin-right: 0 !important;
    }
}
</style>

